import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import type { Task } from '@/types/task';

export const useTask = (taskId: string | null) => {
  const { company } = useAuth();

  return useQuery({
    queryKey: ['task', taskId],
    queryFn: async (): Promise<Task | null> => {
      if (!taskId) return null;
      const { data, error } = await supabase
        .from('tasks')
        .select(`
          *,
          section:task_sections(*),
          task_project_memberships!task_project_memberships_task_id_fkey(
            project:projects!task_project_memberships_project_id_fkey(id, name)
          )
        `)
        .eq('id', taskId)
        .eq('company_id', company!.id)
        .maybeSingle();
      if (error) throw error;
      return data as Task | null;
    },
    enabled: !!taskId && !!company?.id,
    staleTime: 30_000,
  });
};
